@if (!edit){
<div class="d-flex w-100 profile-detail-row">
  <p>
    {{ title | translate }}
  </p>
  @if(translationPrefix) {
    <span>{{ translationPrefix + control.value | translate }}</span>
  } @else {
    <span>{{ control.value }}</span>
  }
</div>
}@else {
<div class="p-0 m-0 w-100">
  <p class="rightHeadings">
    {{ subTitle | translate }}
    @if(required){<span class="text-danger">*</span>}
  </p>
  <mat-form-field appearance="outline" class="w-100 small">
    <mat-select [formControl]="control" matNativeControl required>
      <mat-option
        *ngFor="let option of combinedArray"
        mat-stroked-button
        value="{{ option.value }}"
      >
        {{ option.text }}</mat-option
      >
    </mat-select>
  </mat-form-field>
</div>
}
